import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { MessagesContext } from "../../context/MessagesContext";
import ErrorMessage from "./ErrorMessage";

export default function DisplayMessages() {
  const { messages, dismissMessage } = useContext(MessagesContext);
  const [current, setCurrent] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!Array.isArray(messages) || messages.length === 0) {
      setCurrent(null);
    } else {
      setCurrent(messages[0]);
    }
  }, [messages])

  const onRequestClose = () => {
    dismissMessage(current);
  };

  const onConfirm = async () => {
    setIsSaving(true);
    await current.handleConfirm();
    setIsSaving(false);
    dismissMessage(current);
  };

  switch (current?.type) {
    case "error":
      return <ErrorMessage message={current} onRequestClose={onRequestClose} isOpen={true} />;
    case "confirmation":
      return <ErrorMessage message={current} onConfirm={onConfirm} onRequestClose={onRequestClose} isOpen={true} isSaving={isSaving} />;
    default:
      return null;
  }
}
